<template>
  <div>
    <h4 class="content-block">Daftar Gaji pakai lookup</h4>

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <p class="text-muted font-weight-light">Lihat Gaji</p>
        <div class="row">
          <!-- <div class="editors"> -->
          <div class="editors-container">
            <div class="col">
              <DxSelectBox
                :dataSource="bulanSource"
                valueExpr="id"
                displayExpr="name"
                width="100%"
                label="Periode Bulan"
                placeholder="Periode Bulan"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                v-model="filters.bulan"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>
            <div class="col" style="padding-left: 10px">
              <DxSelectBox
                :dataSource="tahunSource"
                width="100%"
                label="Periode Tahun"
                placeholder="Periode Tahun"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                v-model="filters.tahun"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>
            <div class="col" style="padding-left: 10px">
              <DxSelectBox
                :dataSource="pegawaiStatusSource"
                valueExpr="id"
                displayExpr="nama"
                width="100%"
                label="Pilih Pegawai"
                placeholder="Pegawai"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                v-model="filters.pegawai_status_id"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>
            <!-- <div class="col" style="padding-left: 10px">
              <DxSelectBox
                :dataSource="skemaGajiSource"
                valueExpr="id"
                displayExpr="nama"
                width="100%"
                label="Pilih Skema Penggajian"
                placeholder="Skema Penggajian"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                v-model="filters.gaji_skema_id"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div> -->
            <div class="col" style="padding-left: 10px">
              <DxButton
                @click="validateFilter"
                text="Lihat Gaji"
                styling-mode="filled"
                type="default"
                class="validate"
                style="float: left"
              />
              <!-- <button class="btn btn-primary float-left mr-2">Button</button> -->
            </div>
          </div>
          <!-- </div> editors-->
        </div>
      </div>
    </div>

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxDataGrid
          ref="gridRef"
          id="gridContainer"
          :data-source="dataSource"
          :allow-column-reordering="true"
          :show-borders="true"
          key-expr="id"
          @editor-preparing="oneditorpreparing"
          :show-column-lines="false"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          @option-changed="onPageChanged"
          @load="onDataGridLoad"
          @exporting="onExporting"
        >
          <!-- :columns="columns" -->
          <!-- :focused-row-enabled="true"
          :focused-row-index="0" -->
          <DxFilterRow :visible="true" />
          <dx-pager :show-page-size-selector="true" :show-info="true" />
          <DxPaging :enabled="true" :page-size="numberingPageSize" />
          <DxExport :enabled="true" :allow-export-selected-data="true" />
          <DxEditing
            :allow-updating="false"
            :allow-deleting="false"
            :allow-adding="false"
            mode="row"
          />
          <DxToolbar>
            <DxItem name="groupPanel" />
            <DxItem name="addRowButton" show-text="always" />
            <DxItem name="exportButton" />
            <DxItem name="columnChooserButton" />
            <DxItem name="searchPanel" />
          </DxToolbar>

          <DxSelection mode="multiple" />
          <DxColumnFixing :enabled="true" />
          <DxColumn
            caption="No."
            data-field="created_at"
            cell-template="numberingTemplate"
            :allow-filtering="false"
            :allow-sorting="false"
          />

          <template #numberingTemplate="{ data }">
            {{ numberingPageNumber * numberingPageSize + data.rowIndex + 1 }}
          </template>
          <DxColumn data-field="pegawai_id" caption="NIK">
            <DxLookup
              :data-source="pegawaiSource"
              value-expr="id"
              display-expr="nik"
            />
          </DxColumn>

          <!-- <DxColumn data-field="simpegPegawai.nik" caption="NIK"> </DxColumn> -->

          <DxColumn data-field="pegawai_id" caption="Nama">
            <DxLookup
              :data-source="pegawaiSource"
              value-expr="id"
              display-expr="nama"
            />
          </DxColumn>
          <DxColumn data-field="golongan_id" caption="Gol.">
            <DxLookup
              :data-source="golonganSource"
              value-expr="id"
              display-expr="nama"
            />
          </DxColumn>

          <!-- <dx-column
            cell-template="diff-cell-template"
            :fixed="true"
            fixed-position="right"
            :allow-sorting="false"
            data-field="pegawai_id"
            caption=" "
            :allow-exporting="false"
            :allow-filtering="false"
          >
          </dx-column> -->

          <!-- <template #diff-cell-template="{ data }">
            <DxDropDownButton
              :items="options"
              icon="menu"
              :id="data.text"
              :show-arrow-icon="false"
              :drop-down-options="{ width: 100 }"
              @item-click="onItemClick"
            />
          </template> -->
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
<script>
import axios from "axios";
import notify from "devextreme/ui/notify";
import { DxValidator, DxRequiredRule } from "devextreme-vue/validator";
import DxButton from "devextreme-vue/button";
import DxSelectBox from "devextreme-vue/select-box";
import ODataStore from "devextreme/data/odata/store";
import { DateTime } from "luxon";
import DataSource from "devextreme/data/data_source";
import _ from "lodash";
// import DxDropDownButton from "devextreme-vue/drop-down-button";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxToolbar,
} from "devextreme-vue/data-grid";
// import { toHandlerKey } from "vue";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";

const months = [
  { name: "Januari", id: 1 },
  { name: "Februari", id: 2 },
  { name: "Maret", id: 3 },
  { name: "April", id: 4 },
  { name: "Mei", id: 5 },
  { name: "Juni", id: 6 },
  { name: "Juli", id: 7 },
  { name: "Agustus", id: 8 },
  { name: "September", id: 9 },
  { name: "Oktober", id: 10 },
  { name: "November", id: 11 },
  { name: "Desember", id: 12 },
];

const currentYear = DateTime.now().toFormat("yyyy");
const currentMonth = DateTime.now().toFormat("M");
const years = [currentYear, Number(currentYear) + 1];

export default {
  components: {
    DxSelectBox,
    DxButton,
    DxValidator,
    DxRequiredRule,
    DxDataGrid,
    DxColumn,
    DxPager,
    DxPaging,
    DxEditing,
    DxFilterRow,
    DxLookup,
    DxColumnFixing,
    DxSelection,
    DxExport,
    DxToolbar,
    // DxDropDownButton,
  },
  data() {
    return {
      golonganSource: new ODataStore({
        url: "http://127.0.0.1/odata/Golongans",
        key: "id",
      }),
      pegawaiSource: new ODataStore({
        url: "http://127.0.0.1/odata/SimpegPegawais",
        key: "id",
      }),
      pegawaiGajiDetailSource: new ODataStore({
        url: "http://127.0.0.1/odata/PegawaiGajiDetails",
        key: "id",
      }),
      numberingPageSize: 10,
      numberingPageNumber: 0,
      // dataSource: [
      //   {
      //     ID: 0,
      //     pegawai_id: "",
      //   },
      // ],
      dataSource: [],
      filters: {
        bulan: Number(currentMonth),
        tahun: currentYear,
        pegawai_status_id: "",
        gaji_skema_id: "",
      },
      bulanSource: months,
      tahunSource: years,
      stylingMode: "outlined",
      //outlined, filled, underlined
      labelMode: "floating",
      pegawaiStatusSource: new ODataStore({
        url: "http://127.0.0.1/odata/PegawaiStatuses",
        key: "id",
      }),
      skemaGajiSource: null,
    };
  },
  methods: {
    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Gaji");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Gaji Pegawai " +
              this.filters.pegawai_status_id +
              " Periode Bulan " +
              this.filters.bulan +
              " " +
              this.filters.tahun +
              ".xlsx"
          );
        });
      });
      e.cancel = true;
    },

    onDataGridLoad() {
      const datagrid = this.$refs.gridRef.instance;
      datagrid.endCustomLoading();
    },
    onPageChanged(e) {
      if (e.fullName == "paging.pageIndex") {
        this.numberingPageSize = this.$refs.gridRef.instance.pageSize();
        this.numberingPageNumber = e.value;
      }
    },
    addColumn(cols) {
      const datagrid = this.$refs.gridRef.instance;
      datagrid.beginUpdate();
      cols.forEach((col) => {
        _.set(col, "lookup", {
          dataSource: this.pegawaiGajiDetailSource,
          displayExpr: "jml",
          valueExpr: "id",
        });

        datagrid.addColumn(col);
      });
      datagrid.endUpdate();
    },
    validateFilter(e) {
      const result = e.validationGroup.validate();

      if (!result.isValid) return 0;
      //reset datagrid col, biar ga nge add!

      //lakukan update kolom berdasarkan skema gaji komponen
      const config = {
        headers: {
          "content-type": "application/json",
        },
      };
      // let dataFin = JSON.stringify(data);
      var data = {
        bulan: this.filters.bulan,
        tahun: this.filters.tahun,
        gaji_skema_id: this.filters.gaji_skema_id,
        pegawai_status_id: this.filters.pegawai_status_id,
      };
      axios
        .post("http://127.0.0.1/api/return_gaji_columns", data, config)
        .then((response) => {
          const datagrid = this.$refs.gridRef.instance;
          datagrid.state({});
          this.dataSource = null;
          this.filters.gaji_skema_id = response.data.gaji_skema_id;
          // const datagrid = this.$refs.gridRef.instance;
          datagrid.beginCustomLoading("Loading...");

          this.addColumn(response.data.columns);
          this.getGaji();
        })
        .catch((error) => {
          console.log(error);
          notify(error.response.data.message, "error");
          this.dataSource = null;
        });
    },

    async generateGaji() {
      const config = {
        headers: {
          "content-type": "application/json",
        },
      };
      // let dataFin = JSON.stringify(data);
      var data = {
        bulan: this.filters.bulan,
        tahun: this.filters.tahun,
        gaji_skema_id: this.filters.gaji_skema_id,
        pegawai_status_id: this.filters.pegawai_status_id,
      };
      await axios
        // .post("http://127.0.0.1/api/return_gaji", data, config)
        .post("http://127.0.0.1/api/gaji_final_kontrak_honor", data, config)
        .then((response) => {
          notify(response.data.message, "success");
          const datagrid = this.$refs.gridRef.instance;
          datagrid.beginCustomLoading("Loading...");

          this.addColumn(response.data.columns);
          this.getGaji();
        })
        .catch((error) => {
          console.log(error);
          notify(error.data.message, "error");
        });
    },

    async getGaji() {
      // this.dataSource = await getGaji();
      // var tempGajiSkemaId = this.filters.gaji_skema_id;
      // var tempTgl = this.filters.tahun + "-" + this.filters.bulan + "-01";

      this.dataSource = new DataSource({
        requireTotalCount: true,
        store: new ODataStore({
          // ODataStore is configured here
          url: "http://127.0.0.1/odata/PegawaiGajis",
          key: "id",
          version: 4,
          beforeSend: function (e) {
            e.headers = {
              "odata-version": "4.0",
            };
          },
          onLoaded: () => {
            const datagrid = this.$refs.gridRef.instance;
            datagrid.endCustomLoading();
          },
        }),

        expand: [
          "simpegPegawai",
          "pegawaiGajiDetails",
          "pegawaiGajiDetails($expand=gajiSkemaKomponen)",
          "pegawaiGajiDetails($expand=gajiSkemaKomponen($expand=gajiItem))",
        ],
        // [
        //   "simpegPegawai,pegawaiGajiDetails,pegawaiGajiDetails($expand=gajiSkemaKomponen),pegawaiGajiDetails($expand=gajiSkemaKomponen($expand=gajiItem))",
        // ],
        filter: [
          ["gaji_skema_id", this.filters.gaji_skema_id],
          "and",
          ["tgl_gaji", this.filters.tahun + "-" + this.filters.bulan + "-01"],
        ],
        // [["gaji_skema_id", 2], "and", ["tgl_gaji", "2023-10-01"]],
      });
    },
  },
};
</script>
